<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconkaoshi1"></i>
      学生信息
    </div>
    <div class="padding-sm ">
      <div class="exam-link">
        <div class="link-form">
          <div v-for="(item,index) in signSome" :key="index">
            <div class="link-form-item" v-if="item.type === 1">
              <p class="link-form-title">{{ item.name }} : {{item.diy_value}}</p>
            </div>
            <div class="link-form-item" v-if="item.type === 2">
              <p class="link-form-title">{{ item.name }} : {{item.diy_value}}</p>
            </div>

            <div class="link-form-item" v-if="item.type === 3">
              <p class="link-form-title">{{ item.name }} : {{item.option[Number(item.diy_value) - 1]}}</p>

            </div>
            <div class="link-form-item" v-if="item.type === 4">
              <p class="link-form-title">{{ item.name }} :
                <span class="margin-right" v-for="(items,j) in item.chiose" :key="j">{{item.option[items]}}</span>
              </p>

            </div>
            <div class="link-form-item" v-if="item.type === 5">
              <p class="link-form-title">{{ item.name }}</p>
              <el-image
                  style="width: 300px; height: 200px"
                  fit="cover"
                  :src="imgUrl + item.diy_value"
                  :preview-src-list="[imgUrl + item.diy_value]">
              </el-image>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {orgExamStudentInfo} from "@/api/fuse";
import {IMGURL} from "@/config";

export default {
  name: "examineeDetail",
  data() {
    return {
      mianfei:'',
      shoufei:'',
      name:'',
      formList:[]
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/fuse/exam',
        "当前位置：考试管理 > 学生信息",
        true
    );
    this.getExamEnroll()
  },
  computed:{
    imgUrl(){
      return IMGURL
    },
    signSome() {
      let _arr = JSON.parse(JSON.stringify(this.formList))
      _arr.map(item => {
        if (item.type === 3 ) {
          item.value = item.value.split('|')
          item.option = []
          item.value.map(items => {
            items = items.split(',')
            item.option.push(items[1])
          })
        }
        if(item.type === 4){
          item.value = item.value.split('|')
          item.option = []
          item.chiose = item.diy_value.split(',')
          item.value.map(items => {
            items = items.split(',')
            item.option.push(items[1])
          })
        }

      })
      return _arr
    },
  },

  methods: {
    async getExamEnroll(){
      let _data = await orgExamStudentInfo(this.$route.query.id)
      this.formList = _data.data.list
    }
  }
};
</script>

<style scoped lang="scss">

.exam-link{
  width: 70%;
  margin: 30px auto;
  padding: 30px;
  border-radius: 8px;
  border: solid 2px #e1e1e1;
  .link-form{
    padding: 30px 0;
    h3{
      text-align: center;
      font-size: 20px;
      line-height: 40px;
    }
    .link-form-item{
      margin-bottom: 10px;
      .link-form-title{
        line-height: 36px;
        font-size: 16px;


      }
      .link-form-desc{
        font-size: 14px;
        color: #999;
        line-height: 24px;
      }
      .up-box{
        border: 1px solid #eee;
        padding: 30px;
        color: #999;
        text-align: center;
      }
      .el-select{
        width: 100%;
      }
      .file-box{
        padding: 20px;
        border-radius: 4px;
        border: solid 1px #e2e2e2;
      }
    }
  }
}


</style>

